import mixpanel from 'mixpanel-browser'
import { type AnyAggregate, type AnyFilter, type AnyNode } from 'common'
import type { SubscriptionState } from '@/views/app/Datasets/DatasetBuilderView.vue'

const track = (event: string, properties: Record<string, any> = {}): void => {
  mixpanel.track(event, { ...properties, location: 'query_builder' })
}

const updatedSelectedColumns = (selectedColumns: AnyNode[]): void => {
  track('selected_columns', { selectedColumns })
}

const renameColumn = (columnName: AnyNode, alias: string): void => {
  track('rename_column', { column_name: columnName, alias })
}

const resetColumnName = (columnName: AnyNode): void => {
  track('reset_column_name', { column_name: columnName })
}

const aggregateColumn = (columnName: AnyNode, aggregate: AnyAggregate) => {
  track('aggregate_column', { column_name: columnName, aggregate_fnc: aggregate })
}

const resetColumnAggregate = (columnName: AnyNode): void => {
  track('reset_column_aggregate', { column_name: columnName })
}

const formatColumn = (columnName: AnyNode, format: string): void => {
  track('format_column', { column_name: columnName, format })
}

const removeColumn = (columnName: AnyNode): void => {
  track('remove_column', { column_name: columnName })
}

const removeFilter = (columnName: AnyNode): void => {
  track('remove_filter', { column_name: columnName })
}

const appliedFilter = (columnName: AnyNode, value: AnyFilter): void => {
  track('applied_filter', {
    column_name: columnName,
    value
  })
}

const addAllColumnsFromCategory = (category: string): void => {
  track('add_all_from_category', { category })
}

const refreshQueryBuilderClicked = () => {
  track('refresh_btn_click')
}

const loadedExample = (exampleName: string) => {
  track('loaded_example', {
    example_name: exampleName
  })
}

const generateQueryWithAI = () => {
  track('generate_query_with_ai')
}

const downloadDataDictionary = () => {
  track('download_data_dictionary')
}

const exportDataset = (format: 'csv' | 'jsonl') => {
  track('export_dataset', {
    format
  })
}

const showedAPIEquivalentMenu = () => {
  track('showed_api_equivalent_menu')
}

const setDatasetSchedule = (schedule: SubscriptionState, frequency: 'weekly' | 'monthly') => {
  track('set_dataset_schedule', { frequency, emails: schedule.emails })
}

const clearAll = () => {
  track('clear_all')
}

const duplicateDataset = () => {
  track('duplicate_dataset')
}

export default {
  updatedSelectedColumns,
  renameColumn,
  resetColumnName,
  aggregateColumn,
  resetColumnAggregate,
  formatColumn,
  removeColumn,
  removeFilter,
  appliedFilter,
  addAllColumnsFromCategory,
  refreshQueryBuilderClicked,
  loadedExample,
  generateQueryWithAI,
  downloadDataDictionary,
  exportDataset,
  showedAPIEquivalentMenu,
  setDatasetSchedule,
  clearAll,
  duplicateDataset
}
